import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

const SvgIdea = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <Path
                fill={baseColors.black}
                d="M10 2.343a.586.586 0 000 1.172 3.52 3.52 0 013.516 3.516.586.586 0 001.171 0A4.693 4.693 0 0010 2.343z"
            />
            <Path
                fill={baseColors.black}
                d="M8.49.157C5.842.711 3.696 2.837 3.13 5.5c-.477 2.25.11 4.508 1.612 6.196a4.565 4.565 0 011.155 2.991v1.172c0 .78.51 1.442 1.215 1.671C7.345 18.9 8.533 20 10 20s2.655-1.101 2.887-2.47a1.76 1.76 0 001.215-1.671v-1.172c0-1.079.422-2.155 1.189-3.03a7.016 7.016 0 001.74-4.626c0-4.436-4.06-7.81-8.541-6.874zM10 18.827c-.753 0-1.414-.518-1.657-1.214h3.314c-.243.697-.904 1.215-1.657 1.215zm2.93-2.968a.587.587 0 01-.586.586H7.656a.587.587 0 01-.586-.586v-.586h5.86v.586zm1.48-4.974c-.818.932-1.32 2.056-1.448 3.216H7.038a5.79 5.79 0 00-1.419-3.184C4.368 9.51 3.88 7.624 4.277 5.743c.466-2.196 2.255-3.98 4.452-4.438C12.48.52 15.86 3.338 15.86 7.03a5.845 5.845 0 01-1.45 3.854zM1.758 7.03H.586a.586.586 0 000 1.173h1.172a.586.586 0 000-1.172zM2 4.101l-.828-.828a.586.586 0 10-.829.828l.829.829A.586.586 0 102 4.1zm0 6.203a.586.586 0 00-.828 0l-.829.828a.586.586 0 10.829.829L2 11.132a.586.586 0 000-.828zM19.414 7.03h-1.172a.586.586 0 000 1.173h1.172a.586.586 0 000-1.172zm.243-3.757a.586.586 0 00-.829 0L18 4.1a.586.586 0 00.83.829l.828-.829a.586.586 0 000-.828zm0 7.859l-.829-.828a.586.586 0 10-.829.828l.83.829a.586.586 0 10.828-.829z"
            />
        </Svg>
    )
}

export default SvgIdea
